import React, { useState } from "react";
import Metriccard from "../Metriccard";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const Psfaccordian = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full border rounded-lg shadow-sm overflow-hidden">
      {/* Accordion Header */}
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-2 text-gray-700 text-lg font-semibold bg-blue-300"
      >
        {/* Blinking text only when closed */}
        <div className={`flex-1 text-center`}>
          Customer Experience Metrics
        </div>

        {/* Blinking arrow only when closed */}
        <div className={`ml-auto ${!open ? "blink" : ""}`}>
          {open ? <IoIosArrowUp size={28}/> : <IoIosArrowDown size={28}/>}
        </div>
      </button>

      <style jsx>{`
        @keyframes blink-animation {
          0%,
          50%,
          100% {
            opacity: 1;
          }
          25%,
          75% {
            opacity: 0;
          }
        }
        .blink {
          animation: blink-animation 5s infinite;
        }
      `}</style>

      {/* Accordion Content */}
      {open && (
        <div className="p-2 h-54 justify-center justify-items-centervc  bg-white text-black text-sm">
          <Metriccard />
        </div>
      )}
    </div>
  );
};

export default Psfaccordian;
